import { ComponentProps, PropsWithChildren } from 'react'
import { LuInfo } from 'react-icons/lu'

import { IconButton } from '@/lib/core/components/Button'
import { Tooltip } from '@/lib/core/components/Tooltip'

import styles from './InfoTooltip.module.css'

export const InfoTooltip = ({
  children,
  ...forward
}: PropsWithChildren<Omit<ComponentProps<typeof Tooltip>, 'children' | 'tooltipContent'>>) => {
  return (
    <Tooltip
      interactive
      trigger="click"
      arrowOffset={50}
      contentPadding={3}
      placement="top"
      {...forward}
      tooltipContent={<div className={styles.infoTooltip}>{children}</div>}
    >
      <IconButton type="button" $variant="primary" data-testid="info-tooltip-trigger">
        <LuInfo size="16" />
      </IconButton>
    </Tooltip>
  )
}
